import _ from 'lodash'
import type { PageJson, Structure } from '@wix/thunderbolt-becky-types'

type StructureAndData = { data: PageJson['data']; structure: Structure }

const fixStructure = (flatStructure: StructureAndData['structure']): StructureAndData['structure'] => {
	// @ts-ignore
	return _.mapValues(flatStructure, (comp) => {
		return {
			...comp,
			layout: undefined,
		}
	})
}

const oneDocFixerForPage = (structureAndData: StructureAndData): StructureAndData => {
	const { data, structure } = structureAndData

	const fixedFlatStructure = fixStructure(structure)

	return {
		structure: fixedFlatStructure,
		data,
	}
}

export default oneDocFixerForPage
